
















































































































































import {Component, Vue, Watch, Prop, Model} from 'vue-property-decorator';
import SelectionListFilterMenu from './SelectionListFilterMenu.vue';
import SelectionListGroupingMenu from './SelectionListGroupingMenu.vue';
import {FilterItem, SelectionListFilterModel, SelectionListGroupingModel} from './interfaces';
import {groupBy} from 'lodash';

@Component({
  components: {
    SelectionListFilterMenu,
    SelectionListGroupingMenu,
  },
})
export default class SelectionList extends Vue {
  // Элементы для выбора
  @Prop({required: true, type: Array})
  items!: [];

  // Показатель применения сортировки к списку
  @Prop({required: false, type: Boolean, default: true})
  sorted!: boolean;

  // Показатель возможности выбора нескольких элементов
  @Prop({required: false, type: Boolean, default: true})
  multiple!: boolean;

  // Поле для определения enabled статуса у элементов
  @Prop({required: false, default: null})
  enabledFieldName!: string | null;

  // Поле для определения enabled статуса у элементов
  @Prop({required: false, default: null})
  disabledFieldName!: string | null;

  // Ключевое поле у элементов
  @Prop({required: false, default: 'id'})
  keyFieldName!: string;

  // Показывать кнопку Все
  @Prop({required: false, default: false})
  showSelectAllButton!: boolean;

  @Prop({required: false, default: false})
  showCheckboxWithTooltip!: boolean;

  @Prop({required: false})
  tooltip!: string;

  checkboxModel = false;

  @Watch('checkboxModel')
  onChangeCheckboxModel(newVal: any) {
    this.$emit('onChangeCheckboxModel', newVal);
  }

  @Prop({required: false, default: false})
  showTooltip!: boolean;

  get allSelect() {
    return this.selectedItemKeys.length == this.filteredItems.length;
  }

  set allSelect(value: boolean) {
    if (value) this.changeSelectedItems = this.filteredItems.map((x: any) => this.getKey(x));
    else this.changeSelectedItems = [];
  }

  // Показывать тулбар
  get showToolbar() {
    return this.showSearch || this.filter || this.groupings;
  }

  // Получить ключ элемента
  getKey(item: any) {
    return item[this.keyFieldName];
  }

  // Получить enabled статус элемента
  isEnabled(item: any) {
    if (this.enabledFieldName) return item[this.enabledFieldName];
    if (this.disabledFieldName) return !item[this.disabledFieldName];
    return true;
  }

  // Модель для ключей элементов
  @Model('change') selectedItemKeys!: any;

  get changeSelectedItems() {
    return this.selectedItemKeys;
  }

  set changeSelectedItems(newSelectedItemKeys: any) {
    this.$emit('change', newSelectedItemKeys);
  }

  // Список отфильтрованных элементов при поиске и\или фильтре
  selectedFilterItems: FilterItem[] = [];

  get filteredItems() {
    let items: any[] = this.items.filter(
      (x: any) =>
        !this.search ||
        this.selectedItemKeys === this.getKey(x) ||
        this.selectedItemKeys?.includes(this.getKey(x)) ||
        x.name.toLowerCase().includes(this.search.toLowerCase()),
    );
    if (this.selectedFilterItems.length)
      items = this.getFilteredItems(items, this.selectedFilterItems);
    return items;
  }

  created() {
    this.selectedFilterItemKeys = [];
    this.selectedGrouping = null;

    if (this.sorted) this.items.sort((x: any, y: any) => x.name.localeCompare(y.name));
  }

  /* Поиск */

  // Показывать ли поиск
  @Prop({required: false, type: Boolean, default: false})
  showSearch!: boolean;

  // Строка поиска
  search = '';

  // Очистить строку поиска
  clearSearch() {
    this.search = '';
  }

  /* */

  /* Фильтрация */

  // Фильтр
  @Prop({required: false})
  filter!: SelectionListFilterModel | null;

  // Статус кнопки фильтра
  filterStatus = false;

  // Список выбранных элементов в фильтре
  selectedFilterItemKeys: string[] = [];

  //Модель для v-alert фильтра
  get filterInfo() {
    return this.filterStatus;
  }
  set filterInfo(value: boolean) {
    if (!value) this.clearFilter();
  }

  //Строка v-alert фильтра
  get filterStr() {
    return `${this.filter?.name}: ${this.selectedFilterItems.map(x => x.value).join()}`;
  }

  // Список элементов фильтра
  get filterItems() {
    if (!this.filter) return [];
    const filterItems: any[] = [];
    const groups = groupBy(this.items, this.filter.keyFieldName);
    for (const key in groups) {
      const values = groups[key];
      if (values) {
        const aliasFieldName = this.filter.aliasFieldName
          ? this.filter.aliasFieldName
          : this.filter.keyFieldName;
        filterItems.push({key: key, value: values[0][aliasFieldName]});
      }
    }
    return filterItems;
  }

  // Применить фильтр
  applyFilter() {
    if (!this.selectedFilterItemKeys.length) {
      this.clearFilter();
      return;
    }
    this.selectedFilterItems = this.filterItems.filter(x =>
      this.selectedFilterItemKeys.includes(x.key),
    );
    this.filterStatus = true;
  }

  // Очистить фильтр
  clearFilter() {
    this.selectedFilterItemKeys = [];
    this.selectedFilterItems = [];
    this.filterStatus = false;
  }

  // Получить отфильтрованные элементы выбора
  getFilteredItems(items: any[], selectedFilterItems: FilterItem[]): any[] {
    if (!this.filter) return items;
    const keyFieldName = this.filter.keyFieldName;
    const keys = selectedFilterItems.map(x => x.key);
    return items.filter(
      (x: any) =>
        this.selectedItemKeys === this.getKey(x) ||
        this.selectedItemKeys?.includes(this.getKey(x)) ||
        keys.includes(String(x[keyFieldName])),
    );
  }

  /* */

  /* Группировка */

  // Выбранная группировка
  selectedGrouping: SelectionListGroupingModel | null = null;

  // Список группировок
  @Prop({required: false})
  groupings!: SelectionListGroupingModel[] | null;

  // Статус кнопки группировки
  groupingStatus = false;

  //Модель для v-alert группировки
  get groupingInfo() {
    return this.groupingStatus;
  }
  set groupingInfo(value: boolean) {
    if (!value) this.clearGrouping();
  }

  // Применить группировку
  applyGrouping() {
    this.groupingStatus = true;
  }

  // Очистить группировку
  clearGrouping() {
    this.selectedGrouping = null;
    this.groupingStatus = false;
  }

  // Группы элементов выбора
  get itemGroups() {
    if (!this.selectedGrouping) return [];
    const groupingObject = groupBy(this.filteredItems, this.selectedGrouping.keyFieldName);
    const groups: any[] = [];
    for (const key in groupingObject) {
      const noValue = key === 'undefined';
      const title = this.getGroupingTitle(groupingObject[key], noValue);
      groups.push({key: key, items: groupingObject[key], title, noValue});
    }
    groups.sort((x: any, y: any) => {
      if (x.noValue) return 1;
      if (y.noValue) return -1;
      return x.title.localeCompare(y.title);
    });
    return groups;
  }

  // Получить заголовок группировки
  getGroupingTitle(items: any, noValue: boolean) {
    // 'undefined' вместо undefined появляется из-за lodash groupBy
    if (!this.selectedGrouping || noValue) return 'Значение не задано';

    const aliasFieldName = this.selectedGrouping.aliasFieldName
      ? this.selectedGrouping.aliasFieldName
      : this.selectedGrouping.keyFieldName;
    return items[0][aliasFieldName];
  }

  // Строка v-alert группировки
  get groupingStr() {
    return `Группировка: ${this.selectedGrouping?.name}`;
  }

  /* */
}
